import {Component, Input, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { FirebaseService } from '../firebase-service/firebase-service.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit {

  @Input() gallery: any[];

  constructor() {
    this.gallery = [];
  }

  ngOnInit() {

  }

}
